import { render, staticRenderFns } from "./gj-button-group.vue?vue&type=template&id=02a5821b&scoped=true&"
import script from "./gj-button-group.vue?vue&type=script&lang=js&"
export * from "./gj-button-group.vue?vue&type=script&lang=js&"
import style0 from "./gj-button-group.vue?vue&type=style&index=0&id=02a5821b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a5821b",
  null
  
)

export default component.exports